/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.base.platform.notification

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.mohamedrejeb.calf.permissions.ExperimentalPermissionsApi
import com.mohamedrejeb.calf.permissions.Permission
import com.mohamedrejeb.calf.permissions.isGranted
import com.mohamedrejeb.calf.permissions.rememberPermissionState

@OptIn(ExperimentalPermissionsApi::class)
@Composable
fun NotificationPermissionCheckpoint(
    shouldRequest: Boolean,
    title: String,
    description: String,
    confirmText: String,
    dismissText: String,
    onResult: (granted: Boolean) -> Unit,
    onDismiss: () -> Unit,
    content: @Composable () -> Unit,
) {
    val permissionState = rememberPermissionState(Permission.Notification)
    var showDialog by remember { mutableStateOf(false) }

    LaunchedEffect(shouldRequest) {
        if (shouldRequest && permissionState.status.isGranted) {
            onResult(true)
        } else if (shouldRequest && !permissionState.status.isGranted) {
            showDialog = true
        }
    }

    content()

    if (showDialog) {
        NotificationPermissionDialog(
            title = title,
            description = description,
            confirmText = confirmText,
            dismissText = dismissText,
            onConfirm = {
                showDialog = false
                permissionState.launchPermissionRequest()
            },
            onDismiss = {
                showDialog = false
                onDismiss()
            },
        )
    }

    LaunchedEffect(permissionState.status) {
        if (permissionState.status.isGranted && shouldRequest) {
            onResult(true)
        }
    }
}

@OptIn(ExperimentalPermissionsApi::class)
@Composable
fun rememberNotificationPermissionGranted(): Boolean {
    val permissionState = rememberPermissionState(Permission.Notification)
    return permissionState.status.isGranted
}
